import Model from "../../Model";

export interface TAdditionalIncome {
  applicantId: number;
  name: string;
  incomeType: string;
  incomeSource: string;
  dateFrom: string;
  dateTo: string;
  totalIncome: string;
  description: string;
}

export interface IAdditionalIncome extends TAdditionalIncome {}

const AdditionalIncome = Model(
  (model: TAdditionalIncome): IAdditionalIncome => {
    const _additionalIncome: TAdditionalIncome = Object.assign({}, model);

    return {
      get applicantId() {
        return _additionalIncome.applicantId;
      },

      get name() {
        return _additionalIncome.name;
      },

      get incomeType() {
        return _additionalIncome.incomeType;
      },

      get incomeSource() {
        return _additionalIncome.incomeSource;
      },

      get dateFrom() {
        return _additionalIncome.dateFrom;
      },

      get dateTo() {
        return _additionalIncome.dateTo;
      },

      get totalIncome() {
        return _additionalIncome.totalIncome;
      },

      get description() {
        return _additionalIncome.description;
      }
    };
  }
);
export default AdditionalIncome;
